export const currencyFormat = (value, decimal) =>
  new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: (decimal) ? decimal : 0
  }).format(value);
